/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { DatePicker, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import DokanOrderCard from '../card/DokanOrderCard';
import location from '../../assets/images/location.svg';
import { ISOToMDY } from '../../utils/date';
import { createTrackingNumber, handleTrackingNoInput } from '../../redux/orders/ordersActions';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function OrderTracking({ OrderId }) {
    const [showForm, setShowForm] = useState(false);
    const dispatch = useDispatch();
    const { orderTrackingNo, noteLoader } = useSelector((state) => state.orders);
    const handleTrackingInput = (name, value) => {
        // if (name === 'date') {
        //     const dateString = ISOToMDY(value);
        //     dispatch(handleTrackingNoInput({ name, dateString }));
        // }
        dispatch(handleTrackingNoInput({ name, value }));
    };

    const handleUpdate = () => {
        dispatch(createTrackingNumber(orderTrackingNo, OrderId));
    };
    const toggleForm = () => {
        console.log();
        setShowForm(true);
    };

    return (
        <>
            <div>
                <DokanOrderCard hasTitle Title="Tracking Number" hasDivider>
                    <Spin spinning={noteLoader} indicator={antIcon} tip="order note loading">
                        {!showForm && (
                            <div className="grid grid-cols-1">
                                <div className="flex justify-between items-center">
                                    <div>&nbsp;</div>
                                    <div>
                                        <div className="h-20 w-33">
                                            <img
                                                src={location}
                                                alt={location}
                                                className="h-full w-full rounded-full"
                                            />
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div className="flex justify-between items-center mt-6">
                                    <div>&nbsp;</div>
                                    <div>
                                        <div className="text-light_gray">
                                            No tracking number added
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div className="flex justify-center items-center pt-5 pb-10">
                                    <button
                                        type="button"
                                        className="font-extrabold text-mattBlue"
                                        onClick={toggleForm}
                                    >
                                        +Add New
                                    </button>
                                </div>
                            </div>
                        )}

                        {/** tracking no. input form */}
                        {showForm && (
                            <div className="py-8 flex gap-5 flex-col pl-5 pr-10">
                                <div className="flex flex-col flex-grow-1">
                                    <div>
                                        <label className="dokan-normal-font text-dark">
                                            Shipping Provider Name / URL
                                        </label>
                                    </div>

                                    <div>
                                        <input
                                            type="text"
                                            value={orderTrackingNo.provider}
                                            onChange={(value) =>
                                                handleTrackingInput('provider', value.target.value)
                                            }
                                            className="dokan-input mt-2 px-2"
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-between items-center gap-3">
                                    <div className="flex flex-col flex-grow-1">
                                        <div>
                                            <label className="dokan-normal-font text-dark">
                                                Tracking Number
                                            </label>
                                        </div>

                                        <div>
                                            <input
                                                type="text"
                                                value={orderTrackingNo.number}
                                                onChange={(value) =>
                                                    handleTrackingInput(
                                                        'number',
                                                        value.target.value
                                                    )
                                                }
                                                className="dokan-input mt-2 px-2"
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-col flex-grow-1">
                                        <div>
                                            <label className="dokan-normal-font text-dark">
                                                Estimated Date Shipped
                                            </label>
                                        </div>

                                        <div>
                                            <input
                                                type="date"
                                                className="dokan-input mt-2 px-2"
                                                value={orderTrackingNo.date}
                                                onChange={(value) =>
                                                    handleTrackingInput('date', value.target.value)
                                                }
                                            />
                                            {/* <DatePicker
                                            className="dokan-input mt-2 px-2"
                                            value={orderTrackingNo.date}
                                            onChange={(_, valueString) =>
                                                handleTrackingInput('date', valueString)
                                            }
                                        /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-start items-center gap-2">
                                    <button
                                        type="button"
                                        className="bg-slate-gray text-white text-md border border-gray-100 py-3 px-4 rounded-sm"
                                        onClick={handleUpdate}
                                    >
                                        Update
                                    </button>
                                    <button
                                        type="button"
                                        className="border border-gray-300 py-2 px-4 rounded-sm hover:bg-gray-400"
                                        onClick={() => setShowForm(false)}
                                    >
                                        cancel
                                    </button>
                                </div>
                            </div>
                        )}
                    </Spin>
                </DokanOrderCard>
            </div>
        </>
    );
}

export default OrderTracking;
